import CapacityManager from 'actions/routing/capacity_manager';

export default function(context) {
  const capacityManager = new CapacityManager(context);
  return capacityManager;
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_capacity_manager.js